// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3w_x2","type":"styles_type__Jmrz_","choices":"styles_choices__2xHSs"};